/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, ReactElement } from "react";
import axios from "axios";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
} from "@chakra-ui/modal";
import Card from "components/card";
import InputField from "components/fields/InputField";
import SweetAlert2 from "react-sweetalert2";
import { Button } from '@chakra-ui/react';

const BatchDetailErrorModal: React.FC<{
    data: any;
    isOpen: boolean;
    onClose(): void;
}> = ({ data, isOpen, onClose }) => {

    const [errorInfo, setErrorInfo] = useState<any>(data);

    const closeModal = async () => {
        onClose();
        setErrorInfo(data);
    };

    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
                <ModalOverlay className="bg-[#000] !opacity-30" />
                <ModalContent className="dark:!bg-neutral-900 !z-[1002] !m-auto !w-full min-w-[850px] max-w-[850px] !rounded-2xl !border !border-gray-200 !bg-white !shadow-xl dark:!border-white/10 md:!top-[12vh]">
                    <ModalBody className="p-6 md:p-7">
                        <div className="mb-4 flex items-start gap-3">
                            <div className="rounded-xl bg-red-50 p-2 text-red-600 ring-1 ring-red-100 dark:bg-red-900/20 dark:text-red-400 dark:ring-red-900/30">
                                <svg
                                    viewBox="0 0 24 24"
                                    className="h-5 w-5"
                                    fill="currentColor"
                                >
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                                </svg>
                            </div>
                            <div>
                                <h1 className="text-lg font-semibold text-gray-900 dark:text-white">
                                    Error Info
                                </h1>
                                <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">
                                    Details of validation errors found
                                </p>
                            </div>
                        </div>

                        <div className="mb-6 max-h-[60vh] overflow-y-auto">
                            {errorInfo !== null ? errorInfo.filter((x: any) => !x.isValid).map((item: any, index: number) => (
                                <div key={Math.random()}>
                                    {index > 0 && (
                                        <div className="my-4 border-t border-gray-200 dark:border-white/10"></div>
                                    )}
                                    
                                    <div className="rounded-xl border border-red-200 bg-red-50 p-4 dark:border-red-900/40 dark:bg-red-900/20">
                                        <div className="flex flex-col gap-2 text-sm">
                                            {(item.reference || item.reference === "") && (item.bsb || item.bsb === "") && (item.account_number || item.account_number === "") &&
                                                <div className="flex">
                                                    <div className="w-32 shrink-0 font-medium text-red-900 dark:text-red-300">
                                                        CSV Line
                                                    </div>
                                                    <div className="font-semibold text-red-900 dark:text-red-200">
                                                        {item.rowIndex + 4}
                                                    </div>
                                                </div>
                                            }
                                            {(item.reference || item.reference === "") &&
                                                <div className="flex">
                                                    <div className="w-32 shrink-0 font-medium text-red-900 dark:text-red-300">
                                                        Customer ID
                                                    </div>
                                                    <div className="font-semibold text-red-900 dark:text-red-200">
                                                        {item.reference === "" ? "-" : item.reference}
                                                    </div>
                                                </div>
                                            }
                                            {(item.bsb || item.bsb === "") &&
                                                <div className="flex">
                                                    <div className="w-32 shrink-0 font-medium text-red-900 dark:text-red-300">
                                                        BSB
                                                    </div>
                                                    <div className="font-semibold text-red-900 dark:text-red-200">
                                                        {item.bsb === "" ? "-" : item.bsb}
                                                    </div>
                                                </div>
                                            }
                                            {(item.account_number || item.account_number === "") &&
                                                <div className="flex">
                                                    <div className="w-32 shrink-0 font-medium text-red-900 dark:text-red-300">
                                                        Account No.
                                                    </div>
                                                    <div className="font-semibold text-red-900 dark:text-red-200">
                                                        {item.account_number === "" ? "-" : item.account_number}
                                                    </div>
                                                </div>
                                            }
                                            
                                            <div className="mt-2">
                                                <div className="mb-1 font-medium text-red-900 dark:text-red-300">
                                                    {(item.reference || item.reference === "") && (item.bsb || item.bsb === "") && (item.account_number || item.account_number === "") ? "Reason:" : item.rowIndex ? "Footer:" : "Errors:"}
                                                </div>
                                                <ul className="ml-5 list-disc space-y-1 text-red-800 dark:text-red-200">
                                                    {Object.keys(item.errors).map((key) => (
                                                        <li key={Math.random()}>
                                                            <span className="font-medium">{key}:</span> {item.errors[key].message}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )) : (null)}
                        </div>

                        <div className="flex justify-end gap-2">
                            <Button
                                onClick={() => closeModal()}
                                className="rounded-lg bg-primary-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/30"
                            >
                                Close
                            </Button>
                        </div>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};

export default BatchDetailErrorModal;